import { createReducer, createActions } from "reduxsauce";

/* Types & Action Creators */

const { Types, Creators } = createActions({
  getMessages: ["id_from", "id_to", "customer_key", "limit"],
  getMessagesSuccess: ["data"],
  postMessages: ["data"],
  refreshMessages: ["id_from", "id_to", "customer_key"],
  updateMessage: ["id"],
  getPendingMessages: ["id_from", "id_to", "customer_key"],
  getPendingMessagesSuccess: ["data"]
});

export const MessagesTypes = Types;
export default Creators;

/* Initial State */

export const INITIAL_STATE = {
  messages: [],
  pendingMessages: [],
  loading: false
};

/* Reducers */

export const getMessages = (state = INITIAL_STATE, action) => ({
  ...state,
  loading: true
});

export const getMessagesSuccess = (state = INITIAL_STATE, action) => ({
  ...state,
  messages: action.data,
  loading: false
});

export const getPendingMessagesSuccess = (state = INITIAL_STATE, action) => ({
  ...state,
  pendingMessages: action.data
});

/* Reducers to types */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_MESSAGES]: getMessages,
  [Types.GET_MESSAGES_SUCCESS]: getMessagesSuccess,
  [Types.GET_PENDING_MESSAGES_SUCCESS]: getPendingMessagesSuccess
});



// WEBPACK FOOTER //
// ./src/storeChat/ducks/messages.js